// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-spinner {\n  position: absolute;\n  width: 100px;\n  height: 100px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: none; }\n  .loading-spinner.show {\n    display: block;\n    animation: rotating 2s linear infinite; }\n\n@keyframes rotating {\n  from {\n    transform: translate(-50%, -50%) rotate(0deg); }\n  to {\n    transform: translate(-50%, -50%) rotate(360deg); } }\n  .loading-spinner svg {\n    width: 100%;\n    height: 100%; }\n", ""]);
// Exports
module.exports = exports;
